import { Fragment, useEffect, useState } from "react";
import { Button, useMediaQuery } from "@mui/material";
import { responsiveAppBarStyles } from "../ResponsiveNavbar/styles";
import { CustomTextField } from "../TracksPageComponents/styles";
import { ProjectSearchBarProps } from "./types";

export const ProjectSearchBar: React.FC<ProjectSearchBarProps> = ({
  queryValue,
  setQueryValue,
  setPage,
  setProjects,
}) => {
  const [query, setQuery] = useState<string>("");
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width: 1536px)");

  const handleQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex =
      /^[a-zA-Z0-9\s!@#$%^&*()_+\-={};':"\\|,.<>?/[\]\\√∑∞≠≈±÷×π]*$/;
    if (regex.test(e.target.value)) {
      setQuery(e.target.value);
      setQueryValue(e.target.value);
      setPage(1);
    }
  };

  useEffect(() => {
    if (query.trim() === "") {
      setQueryValue("");
      setPage(0);
      setProjects([]);
    }
  }, [query, setQueryValue, setPage, setProjects]);

  const handleEnterPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" && query.trim() !== "") {
      setQueryValue(query.trim());
      setPage(0);
      setProjects([]);
    }
  };

  const handleSubmitClick = () => {
    if (query.trim() !== "") {
      setQueryValue(query.trim());
      setProjects([]);
      setPage(0);
    } else {
      setQueryValue("");
      setPage(0);
      setProjects([]);
    }
  };

  return (
    <>
      <CustomTextField
        sx={{ width: isSmallScreen ? "90vw" : "320px" }}
        value={query}
        placeholder="Search project"
        onKeyPress={handleEnterPress}
        size={isSmallScreen ? "small" : "medium"}
        onChange={handleQueryChange}
        InputProps={{
          endAdornment: (
            <Fragment>
              <Button
                onClick={handleSubmitClick}
                sx={
                  isMediumScreen
                    ? {
                        ...responsiveAppBarStyles.signupButton,
                        fontSize: "12px",
                        height: "30px",
                        margin: 0,
                      }
                    : responsiveAppBarStyles.signupButton
                }
              >
                Search
              </Button>
            </Fragment>
          ),
        }}
      />
    </>
  );
};
